// This file is auto-generated by generate-env.js. Do not edit manually.
import type { Environment } from './environment.model';
import { tierRanges, SUPPORTED_NETWORK } from './config';

export const environment: Environment = {
    ...{
        APPKIT_PROJECT_ID: "8d4246b4864adf3c8d6fabc0171b3ab0",
        PROJECT_ID: "53b5566b92708732ca6761dc365ff889",
        CONTRACT_ADDRESS: "0x78524Bd7D4555B57fDb7Fb403180F311cB52eC79",
        CURRENCY_SYMBOL: "USDT",
        PROJECT_URL: "https://dev-presale.aqualuxwellnessgroup.com/",
        ENCRYPT_LOCAL_STORAGE: false,
        LOCAL_STORAGE_SECRET: "AXZ86Q2M84E3400875663E8366912AY76365488H",
        API_BASE_URL: "https://dev-api.aqualuxwellnessgroup.com/",
        AQLX_TOKEN_ADDRESS: "0x38f5a859404b1a73da7acb2D9E79f3Db5ea6DB98",
        production: false,
        PROVIDERS: {
            sepolia: "https://eth-sepolia.g.alchemy.com/v2/Ehx84XSejJSJRNvl0EqCMokHaTmEEKlP"
        }
    },
    tierRanges,
    SUPPORTED_NETWORK,
};
